export default "__VITE_ASSET__Ctk81Cg5__"